import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useCandidatoNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    history.push(`/pages/candidato/editar/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    history.push('/pages/candidato/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    history.push(`/pages/candidato/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
